export default {
      id: "huge-bmp-usage",
      viewBox: "0 0 41 40",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#huge-bmp",
      toString: function () {
        return this.url;
      }
    }